// extracted by mini-css-extract-plugin
module.exports = {"feedItem":"KauphollFeedItem-module--feedItem--quhG_"};